import { render, staticRenderFns } from "./StudentMatch.vue?vue&type=template&id=1dd9a5d6&scoped=true&"
import script from "./StudentMatch.vue?vue&type=script&lang=ts&"
export * from "./StudentMatch.vue?vue&type=script&lang=ts&"
import style0 from "./StudentMatch.vue?vue&type=style&index=0&id=1dd9a5d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd9a5d6",
  null
  
)

export default component.exports